<template>
  <div class="forgeron-main-header forgeron-custom-header p-1">
    <div class="header-content d-flex justify-content-between align-items-center">
      <slot />
    </div>
  </div>
</template>
<script>
import { Link } from '@inertiajs/vue3';

export default {
  props: {},
  components: {
    Link
  },
  setup(props) {
    return {};
  },
}
</script>